/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum IdentityProvider {
  google = 'google',
  open_athens = 'open_athens',
  proxy = 'proxy'
}
